<app-header [onBehalfUsers]="onBehalfUsers"></app-header>
<div class="container-fluid" id="maincontainer" [ngClass]="{'staging-env': config.environment === EnvironmentType.STAGING, 'test-env' : config.environment === EnvironmentType.TEST }">

<app-price-panel></app-price-panel>

  <div class="row">
    <div class="col-12 col-lg-6">
      <app-order-panel></app-order-panel>
    </div>

    <div class="col-12 col-lg-6">
      <app-account-panel></app-account-panel>
    </div>

  </div>


<app-blotter></app-blotter>
</div>
